import { createContext } from 'react'

// Action 类型
interface UserAction {
  type:
    | 'SET_USER_INFO'
    | 'CLEAR_USER_INFO'
    | 'SET_USER_ACCOUNT'
    | 'CLEAR_USER_ACCOUNT'
    | 'SET_USER_ORDER'
    | 'SET_USER_USAGE'
    | 'SET_PAY_ACCOUNT'
  payload: any
}
export type UserState = Record<string, any>

export const UserContext = createContext<UserState | null>(null)
export const initUserState: UserState = {
  userInfo: null,
  account_list: [],
  order_list: [],
  usage_list: [],
  account: []
}

export const userReducer = (state: UserState, action: UserAction): UserState => {
  switch (action.type) {
    case 'SET_USER_INFO':
      return {
        ...state,
        userInfo: action.payload
      }
    case 'SET_PAY_ACCOUNT':
      return {
        ...state,
        account: action.payload
      }
    case 'SET_USER_ACCOUNT':
      return {
        ...state,
        account_list: action.payload
      }
    case 'SET_USER_ORDER':
      return {
        ...state,
        order_list: action.payload
      }
    case 'SET_USER_USAGE':
      return {
        ...state,
        usage_list: action.payload
      }
    case 'CLEAR_USER_INFO':
      return { ...initUserState }
    default:
      return state
  }
}
